import React from 'react';
import { Button, Icon, Modal } from 'components';
import CreatePaymentCash from './modal-create-cash';
import CreatePaymentMobile from './modal-create-mobile';
import CreatePaymentZelle from './modal-create-zelle';

interface Props {
	onClose: () => void;
	onSubmit: () => void;
	item?: any;
}

const METHODS = {
	NONE: 0,
	CASH: 1,
	MOBILE: 2,
	ZELLE: 3,
}

class CreatePayment extends React.Component<Props> {
	state = {
		paymentMethod: METHODS.NONE,
	};

	change = (value: any, target: string) => {
		this.setState(s => ({ ...s, [target]: value }));
	}

	render() {

		return (
			<>
				{this.state.paymentMethod === METHODS.NONE && (
					<Modal
						className="modal-create-notification"
						visible
						onClose={this.props.onClose}
					>
						<div id="modal-create-payment" className="payment-cash">
							<h3>Seleccione el método de pago</h3>
							<button className="close-btn" onClick={this.props.onClose}>
								<Icon name="close" />
							</button>

							<div className="content">
								<Button onClick={() => this.change(METHODS.CASH, 'paymentMethod')}>
									Efectivo
								</Button>
								<Button onClick={() => this.change(METHODS.MOBILE, 'paymentMethod')}>
									Pago móvil
								</Button>
								<Button onClick={() => this.change(METHODS.ZELLE, 'paymentMethod')}>
									Zelle
								</Button>
							</div>

							<div className="actions">
								<Button onClick={this.props.onClose}>
									Cerrar
								</Button>
							</div>
						</div>
					</Modal>
				)}

				{this.state.paymentMethod === METHODS.CASH && (
					<CreatePaymentCash
						onClose={this.props.onClose}
						onSuccess={this.props.onSubmit}
					/>
				)}

				{this.state.paymentMethod === METHODS.MOBILE && (
					<CreatePaymentMobile
						onClose={this.props.onClose}
						onSuccess={this.props.onSubmit}
					/>
				)}

				{this.state.paymentMethod === METHODS.ZELLE && (
					<CreatePaymentZelle
						onClose={this.props.onClose}
						onSuccess={this.props.onSubmit}
					/>
				)}
			</>
		);
	}
}

export default CreatePayment;